import { PropsWithChildren } from 'react';

import { Typography } from '../Typography';

export const TableHeaderCell = ({ children }: PropsWithChildren) => (
  <div className="p-0 pb-2 text-start align-top leading-none text-[13px]">
    <Typography variant="caption-xs" color="tertiary">
      {children}
    </Typography>
  </div>
);
